var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"api-request__route"},[_c('button',{staticClass:"api-request__route-btn"},[_c('span',{staticClass:"type"},[_vm._v(" "+_vm._s(_vm.$props.requestMethod)+" ")]),_c('span',{staticClass:"route"},[_vm._v(" "+_vm._s(_vm.$props.requestRoute)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }